export default "__VITE_ASSET__CXiObv8m__"